import { FC } from 'react'
import { Panel, PanelGroup } from 'react-resizable-panels'
import { useHoteleria } from '../../../../hooks/useHoteleria'
import ContainerWrapper from '../../../central/pages/componentes/Container'
import { renderPanelContent } from '../../components/components'

const ReportCamasPreferentesPageWrapper: FC = () => {
  const { currentTabItem } = useHoteleria()
  return (
    <ContainerWrapper>
      <PanelGroup autoSaveId='example' direction='vertical' style={{ height: '100%' }}>
        <Panel
          collapsible={true}
          order={1}
          key={`panel-hoteleria-header-${currentTabItem.id}`}
          id={`panel-hoteleria-header-${currentTabItem.id}`}
          className={'panel__box'}
          defaultSize={50}
        >
          <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
        </Panel>
      </PanelGroup>
    </ContainerWrapper>
  )
}

export { ReportCamasPreferentesPageWrapper }
